import { inmunetApi } from '../../../api';

export const getData = async(id) => {

    try {

        const { data } = await inmunetApi.get(`/consulta/data/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};

export const getDiagnosticos = async() => {

    try {

        const { data } = await inmunetApi.get(`/consulta/diagnosticos?paginacion=false`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data.diagnosticos;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};

export const getEstudios = async() => {

    try {

        const { data } = await inmunetApi.get(`/consulta/estudios?paginacion=false`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data.estudios;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};

export const createPacienteConsulta = async({ data: consulta, id }) => {

    try {

        const { data } = await inmunetApi.post(`/consulta/${id}`, consulta);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al registrar consulta';

        let consultaData = await getData(id);
        if (!consultaData) {
            consultaData = {};
        }

        return {
            inactivoFlag: false,
            horarioFlag: false,
            empalmadaFlag: false,
            consulta: data.consulta,
            consultaData,
            citaPendiente: data.citaPendiente,
            cita: data.cita
        };

    } catch (error) {

        if (error.response.data.inactivoFlag) {
            return {
                inactivoFlag: true,
                horarioFlag: false,
                empalmadaFlag: false,
                consulta: error.response.data.msg,
                consultaData: {},
                citaPendiente: false,
                cita: false
            };
        } else if (error.response.data.horarioFlag) {
            return {
                inactivoFlag: false,
                horarioFlag: true,
                empalmadaFlag: false,
                consulta: error.response.data.msg,
                consultaData: {},
                citaPendiente: false,
                cita: false
            };
        } else if (error.response.data.empalmadaFlag) {
            return {
                inactivoFlag: false,
                horarioFlag: false,
                empalmadaFlag: true,
                consulta: error.response.data.msg,
                consultaData: {},
                citaPendiente: false,
                cita: false
            };
        } else {
            if (error.response.data.msg) {
                throw new Error(error.response.data.msg);
            } else {
                throw new Error('Error al registrar consulta');
            }
        }

    }

};

export const getHistorial = async(id) => {

    try {

        const { data } = await inmunetApi.get(`/consulta/historial/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener historial de consulta de paciente';

        return data;

    } catch (error) {

        throw new Error('Error al obtener historial de consulta de paciente');

    }

};